/// <amd-module name="Repos/Views/MyPullRequestsFlyoutTab/MyPullRequestsFlyoutTab" />
import * as React from "react";
import { creatorColumn, PullRequestTable, titleColumn } from "Repos/PullRequestList/Components/PullRequestTable";
import { IPullRequestSection } from "Repos/PullRequestList/Contracts";
import { IPullRequestDataProviderService } from "Repos/PullRequestList/PullRequestDataProviderService";
import * as Resources from "Repos/Views/MyPullRequestsFlyoutTab/Resources";
import { IReadyableReadonlyObservableArray } from "VSS/Core/Observable";
import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { onClickFPS } from "VSS/Platform/FPS";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation, routeUrl } from "VSS/Platform/Location";
import { IVssPerformanceService } from "VSS/Platform/Performance";
import { Card } from "VSSUI/Card";
import { ReadyableArrayObserver } from "VSSUI/Observer";
import { Spinner } from "VSSUI/Spinner";
import { ZeroData } from "VSSUI/ZeroData";

class MyPullRequestsFlyoutTab extends VssComponent<{}> {
    private myPullRequestsUrl: string;
    private sections: IReadyableReadonlyObservableArray<IPullRequestSection>;

    constructor(props: {}, context: IVssComponentContext) {
        super(props, context);

        const performanceService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        performanceService.startScenario("my-prs-flyout-tab", false);

        this.myPullRequestsUrl = routeUrl(context.pageContext, "ms.vss-code-web.my-pullrequests-me-page-route");

        const pullRequestDataProviderService = context.pageContext.getService<IPullRequestDataProviderService>("IPullRequestDataProviderService");
        this.sections = pullRequestDataProviderService.getMyWorkPullRequestSections();
    }

    public render() {
        return (
            <div className="flex-column flex-grow scroll-hidden">
                <ReadyableArrayObserver<IPullRequestSection>
                    data={this.sections}
                    dataComponent={this.renderSections}
                    loadingComponent={this.renderSpinner}
                    onReady={this.onLoaded}
                    zeroDataComponent={this.renderZeroData}
                />
                <div className="my-prs-flyout-footer flex-noshrink flex-column flex-stretch text-center font-weight-semibold body-m">
                    <FPSLink href={this.myPullRequestsUrl}>{Resources.ViewMore}</FPSLink>
                </div>
            </div>
        );
    }

    private onLoaded = () => {
        const performanceService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        performanceService.endScenario("Repos", "my-prs-flyout-tab", false);
    };

    private renderSections = (sections: IPullRequestSection[]) => {
        return (
            <div className="my-prs-flyout-content flex-column flex-grow v-scroll-auto rhythm-vertical-16">
                {sections.map(section => (
                    <Card
                        className="flex-noshrink bolt-card-no-vertical-padding"
                        contentProps={{ contentPadding: false }}
                        key={section.title}
                        titleProps={{ text: `${section.title} (${section.countText.value})` }}
                    >
                        <PullRequestTable
                            columns={[creatorColumn, titleColumn]}
                            onActivate={(event, tableRow) => onClickFPS(this.context.pageContext, tableRow.data.linkProps.href, true, event)}
                            pullRequests={section.pullRequests}
                        />
                    </Card>
                ))}
            </div>
        );
    };

    private renderSpinner = () => {
        return (
            <div className="flex-grow flex-column">
                <Spinner />
            </div>
        );
    };

    private renderZeroData = () => {
        return (
            <ZeroData
                className="flex-grow"
                imagePath={getAssetLocation(this.context.pageContext, "ms.vss-code-web/pr-list/Content/emptyPRList.svg")}
                imageAltText={Resources.EmptyPrListSecondary}
                primaryText={Resources.EmptyPrListPrimary}
                secondaryText={Resources.EmptyPrListSecondary}
            />
        );
    };
}

Components.add("vss-code-web-my-prs-flyout-tab", MyPullRequestsFlyoutTab);
